/**
 * Chubb in the Qualitas/ANA comparator.
 * Off by default for every host; a host opts in with `enableChubb: true`.
 * Chubb is served by the widget's own backend (`api/chubb/autos/cotizar` on the widget deploy);
 * hosts never provide a Chubb API.
 */

import { getWidgetPublicBaseUrl } from '@/config/api'
import { WIDGET_SCRIPT_ORIGIN } from '@/config/widgetOrigin'

export interface ChubbLegacyConfig {
  enabled: boolean
  /** Widget deploy origin serving POST /api/chubb/autos/cotizar. Empty = same origin. */
  apiBaseUrl: string
}

let config: ChubbLegacyConfig = {
  enabled: false,
  apiBaseUrl: '',
}

export function setChubbLegacyConfig(next: Partial<ChubbLegacyConfig>): void {
  config = { ...config, ...next }
}

export function getChubbLegacyConfig(): ChubbLegacyConfig {
  return config
}

export function isChubbLegacyEnabled(): boolean {
  return config.enabled === true
}

export function resetChubbLegacyConfig(): void {
  config = { enabled: false, apiBaseUrl: '' }
}

/**
 * Base URL for the widget's Chubb API:
 * explicit `chubbApiBaseUrl` → `widgetPublicUrl` / VITE_WIDGET_PUBLIC_URL → origin of the widget script → same origin.
 */
export function resolveChubbApiBaseUrl(explicit?: string): string {
  if (explicit !== undefined) return explicit
  return getWidgetPublicBaseUrl() || WIDGET_SCRIPT_ORIGIN
}

/** Mount option → Chubb on/off. Undefined means off until each host confirms it wants Chubb. */
export function isChubbEnabledByOption(enableChubb?: boolean): boolean {
  return enableChubb === true
}
